export const CustomerContactPublish = () => {
    return (
        <>
            <div className="fiter_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">연락처 검색</h3>
                    <div className="filter_toolbar"></div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <div className="frm_row search justify-content-start">
                            <label htmlFor="" className="form-label frm_label">검색어</label>
                            <select className="form-select">
                                <option>이름</option>
                            </select>
                            <input type="text"
                                className="form-control"
                            />
                            <button className="btn btn-info btn_search">
                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />조회
                            </button>
                        </div>
                    </div>
                    <div className="col-6">
                    </div>
                </div>
            </div>


            <div className="content_wrap">
                <div className="table_top">
                    <h6 className="table_stats">연락처 목록(<span>13</span>건)</h6>
                    <div className="table_toolbar">
                        <button className="btn btn-dark w-150px px-0"><img src={process.env.PUBLIC_URL + "/assets/images/icon_export.png"} alt="" />엑셀 내보내기</button>
                        <button className="btn btn-primary w-100px px-0 ms-40px">연락처 생성​</button>
                        <button className="btn btn-outline-dark w-100px px-0"><img src={process.env.PUBLIC_URL + "/assets/images/icon_cross.png"} alt="" />선택삭제</button>
                    </div>
                </div>

                <div className="table_scroll">
                    <table className="table table-bordered my_table">
                        <thead>
                            <tr>
                                <th style={{ width: "2.84%" }}>
                                    <div className="checkbox_outer">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                        />
                                    </div>
                                </th>
                                <th>이름<img src={process.env.PUBLIC_URL + "/assets/images/icon-table-sort-down.png"} alt="" />​</th>
                                <th>직함​</th>
                                <th>회사명​</th>
                                <th>부서​</th>
                                <th>팀​</th>
                                <th>산업구분​</th>
                                <th>근무처 전화​</th>
                                <th>휴대폰​</th>
                                <th>회사 이메일​</th>
                                <th>컨택 경로​</th>
                            </tr>
                        </thead>
                        <tbody>
                            {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(() => (
                                <tr>
                                    <td style={{ width: "2.85%" }}>
                                        <div className="checkbox_outer">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                            />
                                        </div>
                                    </td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="pagination-container">
                    <ul>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_first.png"}
                                alt="First Page"
                                className=""
                            />
                        </li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_prev.png"}
                                alt="Previous Page"
                                className=""
                            />
                        </li>
                        <li className="active">1</li>
                        <li className="">2</li>
                        <li className="">3</li>
                        <li className="">4</li>
                        <li className="">5</li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_next.png"}
                                alt="Next Page"
                                className=""
                            />
                        </li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_last.png"}
                                alt="Last Page"
                                className=""
                            />
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
}